<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-input
        v-model="query.fNumber"
        placeholder="产品编码"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fName"
        placeholder="产品名称"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        @row-dblclick="_view"
      >
        <el-table-column prop="fNumber" label="产品编码" />
        <el-table-column prop="fName" label="产品名称" />
        <el-table-column prop="fModel" label="规格" />
        <el-table-column prop="fUnit" label="单位" />
        <el-table-column prop="fQty" label="库存数" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="_view(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      currentEditItem: null
    }
  },
  mounted() {},
  activated() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('BasicInformation/Inventory/InventoryEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    _view: async function(row) {
      var url = this.$route.path + '/' + row.ficItemID
      this.$router.push(url)
    }
  }
}
</script>
